<template>
    <v-container >
        <v-card>
            <v-toolbar dense dark elevation="0">
                <v-toolbar-title>TNS Information</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <SpectroscopicallyTNS></SpectroscopicallyTNS>
            <FooterTNS></FooterTNS>
        </v-card>
    </v-container>
</template>
<script>
import SpectroscopicallyTNS from "@/components/plots/SpectroscopicallyTNS.vue"
import FooterTNS from "@/components/misc/FooterTNS.vue"
export default {
    name: "TNSOverview",
    components: {
        SpectroscopicallyTNS,
        FooterTNS
    },
    data(){
        return {
        }
    },
    methods: {
    }
}
</script>